module.exports = __webpack_public_path__ + "static/media/asteroid.3a8844e5.mp4";